import React, { useState, useEffect } from 'react';
import PlayCanvas from 'components/PlayCanvas/PlayCanvas';
import useStore from 'state/state';

import Overlay from 'components/Overlay/Overlay';
import Requests from 'http/Requests';
import DeviceWarningOverlay from 'components/DeviceWarningOverlay/DeviceWarningOverlay';
import styles from './Home.module.scss';

const Home = () => {
  const [renderPC, setRenderPC] = useState(false);
  const [displayProductDebug, setDisplayProductInstantly] = useState(false);
  const setAppData = useStore((state) => state.setAppData);
  const setContactFormData = useStore((state) => state.setContactFormData);

  const appData = useStore((state) => state.appData);
  const setProductObject = useStore((state) => state.setProductObject);
  const productData = useStore((state) => state.productData);
  const setProductData = useStore((state) => state.setProductData);

  const parseContactFormData = (data) => {
    setContactFormData(data);
  };

  useEffect(() => {
    const loadAppData = async () => {
      const data = await Requests.getAppData();
      setAppData(data);
    };

    if (!appData) {
      loadAppData();
    }
  }, [appData, setAppData]);

  useEffect(() => {
    if (appData) {
      setRenderPC(true);
      setDisplayProductInstantly(false);

      // Get umbraco contact form data if field is not empty.
      if (appData.mainData.contactForm) {
        Requests.getUmracoContactForm(
          appData.mainData.contactForm.formId,
          parseContactFormData
        );
      }
    }
  }, [appData, renderPC, setRenderPC]);

  useEffect(() => {
    if (!displayProductDebug) {
      return;
    }

    setProductObject({
      id: parseInt(0, 10),
      type: parseInt(0, 10),
    });

    const onProductDataLoaded = (data) => {
      setProductData(data);
    };

    const loadProductData = () => {
      Requests.getProductDataById('0', '0', onProductDataLoaded);
    };

    if (!productData) {
      loadProductData('0', '0');
    }
  }, [displayProductDebug, productData, setProductData, setProductObject]);

  return (
    <div className={styles.wrapper}>
      <DeviceWarningOverlay />{' '}
      {renderPC && appData && <PlayCanvas playcanvasData={appData} />}
      <Overlay />
    </div>
  );
};

export default Home;
